import React from "react";
import { NotAvailable } from "lib/SimpleTable";
import { LoadingSpinner } from "lib/Spinner";
import { useFetch } from "lib/useFetch";
import ErrorBoundary from "lib/ErrorBoundary";
import { DisclaimerButtons } from "./DisclaimerButtons";
import { NotFound } from "pages/login/NotFound";
import { useFetchParse } from "../../lib/hooks/useFetchParse";
import { HTMLComponent } from "lib/HTMLComponent";

const JAPI_CONTENT_URL = "/research/japi/content/Disclaimers/";
const JAPI_PUBLIC_CONTENT_URL ="/research/japi/public/content/Disclaimers/";
const JAPI_CONTENT_PREVIEW_URL = "/research/japi/content/preview/Disclaimers/";
const LEGAL_DISCLAIMER_URL = "/research/japi/legal/disclaimer/";

export const Disclaimers = ({ match }) => {
  const { disclaimer } = match.params;
  const isPreview = match.path.includes("/preview/");
  const isMainLegalDisclaimer = disclaimer === "en" || disclaimer === "ja";

  if (isPreview) {
    return <DisclaimerPreview disclaimer={disclaimer} />;
  } else if (isMainLegalDisclaimer) {
    return <MainLegalDisclaimer disclaimer={disclaimer} />;
  } else {
    return <ContentDisclaimer disclaimer={disclaimer} />;
  }
};

// url: /Disclaimers/preview/:disclaimer
const DisclaimerPreview = ({ disclaimer }) => {
  const url = JAPI_CONTENT_PREVIEW_URL + disclaimer;
  const [response, isLoading, isError] = useFetch(url, null, "GET", true);
  return disclaimerView(response?.content, isLoading, isError);
};

// url: /Disclaimers/:disclaimer
const ContentDisclaimer = ({ disclaimer }) => {
  const url = ((disclaimer === "nhi-disclaimer" || disclaimer === "nhi-terms-of-use-en") ? JAPI_PUBLIC_CONTENT_URL : JAPI_CONTENT_URL) + disclaimer;
  const fParser = (res) => res.data[0];
  const [response, isLoading, isError] = useFetchParse(url, null, "GET", true, fParser);
  return disclaimerView(response?.content, isLoading, isError);
};

// url: /Disclaimers/en or /Disclaimers/ja
const MainLegalDisclaimer = ({ disclaimer }) => {
  const url = LEGAL_DISCLAIMER_URL + disclaimer;
  const fParser = (res) => res.data;
  const [content, isLoading, isError] = useFetchParse(url, null, "GET", true, fParser);
  return disclaimerView(content, isLoading, isError);
};

const disclaimerView = (content, isLoading, isError) => {
  if (isLoading) return <LoadingSpinner />;
  if (isError) return <NotAvailable />;
  if (!content) return <NotFound />;

  return (
    <ErrorBoundary>
      <HTMLComponent html={content} className="mt-5 text-break px-2" />
      <DisclaimerButtons />
    </ErrorBoundary>
  );
};
